module.exports = __webpack_public_path__ + "static/img/empty_2.60c41256.png";